import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UpgradeRequestModal from '../../components/UpgradeRequestModal';

export default function WhoViewedMePage() {
    const [views, setViews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showUpgradeModal, setShowUpgradeModal] = useState(false);
    const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

    useEffect(() => {
        const fetchViews = async () => {
            try {
                const token = localStorage.getItem('skillmatch_token');
                const res = await fetch(`${API_URL}/api/candidates/who-viewed-me`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                
                if (res.ok) {
                    const data = await res.json();
                    if (Array.isArray(data)) setViews(data);
                    else setViews([]);
                }
            } catch (err) { console.error(err); setViews([]); } 
            finally { setLoading(false); }
        };
        fetchViews();
    }, [API_URL]);

    if (loading) return <div className="pt-32 text-center text-gray-500">Đang tải dữ liệu...</div>;

    return (
        <div className="min-h-screen bg-[#F8FAFC] pt-28 px-4 pb-20 font-sans">
            <div className="max-w-3xl mx-auto">
                <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 mb-6">
                    <h1 className="text-2xl font-bold text-gray-900 mb-2 flex items-center gap-2">
                        <span className="material-symbols-outlined text-blue-600">visibility</span>
                        Ai đã xem hồ sơ của bạn?
                    </h1>
                    <p className="text-gray-500">Chỉ thành viên <b>PREMIUM</b> mới xem được chi tiết.</p>
                </div>

                <div className="grid gap-4">
                    {views.length > 0 ? views.map((view, idx) => (
                        <div 
                            key={idx} 
                            // ✅ Nếu bị mờ (isBlurred=true) thì click hiện Modal. API backend đã xử lý logic trả về isBlurred cho Pro/Free rồi.
                            onClick={() => view.isBlurred && setShowUpgradeModal(true)}
                            className={`bg-white p-5 rounded-2xl shadow-sm border border-gray-100 flex items-center gap-5 transition-all relative overflow-hidden group 
                                ${view.isBlurred ? 'cursor-pointer hover:shadow-md' : ''}`}
                        >
                            {/* Logo */}
                            <div className={`w-16 h-16 rounded-xl flex items-center justify-center text-xl font-bold text-gray-400 flex-shrink-0 ${view.isBlurred ? 'bg-gray-100 blur-[2px]' : 'bg-white border border-gray-100'}`}>
                                {view.viewerId?.profile?.avatar && !view.isBlurred ? (
                                    <img src={view.viewerId.profile.avatar} className="w-full h-full object-contain rounded-xl" alt="logo" />
                                ) : 'C'}
                            </div>

                            <div className="flex-1 min-w-0">
                                <h3 className={`font-bold text-lg text-gray-900 mb-1 ${view.isBlurred ? 'blur-[5px] select-none opacity-50' : ''}`}>
                                    {view.isBlurred ? "Company Name Hidden" : view.viewerId?.profile?.companyName}
                                </h3>
                                <p className="text-sm text-gray-500 flex items-center gap-1">
                                    <span className="material-symbols-outlined text-sm">location_on</span>
                                    {view.isBlurred ? "Vietnam" : view.viewerId?.profile?.location}
                                </p>
                                <p className="text-xs text-gray-400 mt-2">Xem lúc: {new Date(view.viewedAt).toLocaleString('vi-VN')}</p>
                            </div>

                            {/* LOCK OVERLAY */}
                            {view.isBlurred && (
                                <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/5 opacity-0 group-hover:opacity-100 transition-opacity">
                                    <div className="bg-gray-900 text-white px-4 py-2 rounded-full font-bold text-xs flex items-center gap-2 shadow-xl">
                                        <span className="material-symbols-outlined text-sm text-yellow-400">lock</span>
                                        Mở khóa (Premium)
                                    </div>
                                </div>
                            )}
                            {view.isBlurred && <span className="material-symbols-outlined text-gray-300 text-2xl absolute right-6">lock</span>}
                        </div>
                    )) : (
                        <div className="text-center py-16 bg-white rounded-2xl border border-dashed border-gray-300">
                            <p className="text-gray-500">Chưa có lượt xem nào.</p>
                        </div>
                    )}
                </div>
            </div>

            <UpgradeRequestModal 
                isOpen={showUpgradeModal}
                onClose={() => setShowUpgradeModal(false)}
                title="Tính năng Premium"
                message="Gói Pro chưa hỗ trợ xem chi tiết. Nâng cấp lên PREMIUM để biết chính xác ai đang quan tâm đến bạn."
                targetPlan="Premium"
            />
        </div>
    );
}